import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {AddContactCommand} from '../../../../contacts/store/contact.command';
import {Store} from '@ngrx/store';
import {ContactState} from '../../../../contacts/store/contact.reducer';
import {AddContactAction} from '../../../../contacts/store/contact.action';

@Component({
    standalone: false,
    selector: 'particle-add-contact-dialog',
  templateUrl: './add-contact-dialog.component.html',
  styleUrls: ['./add-contact-dialog.component.css']
})
export class AddContactDialogComponent implements OnInit {

  addContactDetails: any;
  contactSourceType = 'Platfrom-Contact-V2'
  constructor(public dialogRef: MatDialogRef<AddContactDialogComponent>,
              private contactStore: Store<ContactState>) { }

  ngOnInit() {
  }
  onContactValueChanged(event) {
    this.addContactDetails = event;
    console.log(event);
  }
  onAddContact(){
    const addContactCommand = new AddContactCommand(this.addContactDetails.value.firstname,
                                                    this.addContactDetails.value.lastname,
                                                    this.addContactDetails.value.email?.toLowerCase(),
                                                    this.addContactDetails.value.phone,
                                                    '',
                                                    this.addContactDetails.value.message);
    this.contactStore.dispatch(new AddContactAction(this.contactSourceType,addContactCommand));

  }
}
